module.exports = __webpack_public_path__ + "img/logo_white.c50c4dbd.png";